import { render, staticRenderFns } from "./ElementDescTableColumn.vue?vue&type=template&id=37097d2b&scoped=true"
import script from "./ElementDescTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementDescTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementDescTableColumn.vue?vue&type=style&index=0&id=37097d2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37097d2b",
  null
  
)

export default component.exports